import { TextInput } from '@ts/storybook';
import { ExternalLink, WrapperEntitySelector } from '@components/Inputs';
import { IForm } from '@ts/ui-models';
import { useTranslation } from 'react-i18next';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { NewPaperWithPadding } from '@components/Misc';

interface IAssetTabProps extends IForm {}

const AssetTab = (props: IAssetTabProps) => {
  const { mode, values, onCallbackChange } = props;
  const isViewMode = mode === 'view';
  const { t } = useTranslation();

  return (
    <NewPaperWithPadding className="h-auto">
      <TextInput
        isReadOnly={isViewMode}
        label="Notes"
        placeholder=""
        value={values.notes}
        onChangeValue={onCallbackChange('notes')}
      />
      <WrapperEntitySelector
        label="Labels"
        value={values.tagIds}
        searchComponent={generateSearchEntitySelector('tag')}
        isReadOnly={isViewMode}
        onChange={onCallbackChange('tagIds')}
        multiple={true}
      />

      <ExternalLink
        key="link"
        linkLabel={t('URL Link')}
        captionLabel={t('URL Caption')}
        onChangeLink={onCallbackChange('externalHttpLink')}
        onChangeCaption={onCallbackChange('externalHttpLinkCaption')}
        url={values.externalHttpLink}
        caption={values.externalHttpLinkCaption}
        viewFields={props.mode === 'edit' || props.mode === 'new'}
        isReadOnly={isViewMode}
      />
      <ExternalLink
        key="link2"
        linkLabel={t('URL Link 2')}
        captionLabel={t('URL Caption')}
        onChangeLink={onCallbackChange('externalHttpLink2')}
        onChangeCaption={onCallbackChange('externalHttpLinkCaption2')}
        url={values.externalHttpLink2}
        caption={values.externalHttpLinkCaption2}
        viewFields={props.mode === 'edit' || props.mode === 'new'}
        isReadOnly={isViewMode}
      />
      <ExternalLink
        key="link3"
        linkLabel={t('URL Link 3')}
        captionLabel={t('URL Caption')}
        onChangeLink={onCallbackChange('externalHttpLink3')}
        onChangeCaption={onCallbackChange('externalHttpLinkCaption3')}
        url={values.externalHttpLink3}
        caption={values.externalHttpLinkCaption3}
        viewFields={props.mode === 'edit' || props.mode === 'new'}
        isReadOnly={isViewMode}
      />
    </NewPaperWithPadding>
  );
};

export default AssetTab;
